import classNames from 'classnames';
import { ForwardedRef } from 'react';

import MenuIcon from '../icons/MenuIcon';
import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/menu-button.module.css';

interface MenuButtonProps extends BasicButtonProps {
    color?: string;
    circleColor?: string | null;
}

function MenuButton({
    className = null,
    color = 'currentColor',
    circleColor = null,
    ref: buttonRef = null,
    ...props
}: MenuButtonProps & { ref?: ForwardedRef<BasicButtonElement> | null }) {
    return (
        <BasicButton
            ref={buttonRef}
            className={classNames([styles.container, className])}
            {...props}
        >
            <MenuIcon className={styles.icon} color={color} circleColor={circleColor} />
        </BasicButton>
    );
}

export default MenuButton;
